import { createFileRoute } from "@tanstack/react-router";
import React, { Suspense, lazy } from "react";
import SiteHeader from "@/components/common/SiteHeader";
import { useBuildingDetailQuery } from "@/queries/queries";

// Wave-17 Item 1.1 — LL97 overview lazy-loaded.
const LL97SubmissionOverviewPage = lazy(
  () => import("@/pages/Filings/LL97Submission/Overview/Page"),
);

const LL97SubmissionOverviewPageRoute = () => {
  const { buildingId, ll97SubmissionId } = Route.useParams();
  const { data } = useBuildingDetailQuery(buildingId);
  return (
    <div className="flex flex-col w-full min-h-full">
      <SiteHeader
        header={`${data?.name || "Building"} - LL97 Filing`}
        backLink={`/buildings/${buildingId}`}
      />
      <Suspense fallback={null}>
        <LL97SubmissionOverviewPage
          buildingId={buildingId}
          submissionId={ll97SubmissionId}
        />
      </Suspense>
    </div>
  );
};

export const Route = createFileRoute(
  "/buildings_/$buildingId/ll97_/$ll97SubmissionId/overview",
)({
  component: LL97SubmissionOverviewPageRoute,
});
